import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { UserInfo } from 'angular-oauth2-oidc';
import { ToastrService } from 'ngx-toastr';
import { AttendanceService } from '../../services/attendance.service';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { ViewportService } from '../../services/viewport.service';
import { MenuItemInterface } from '../../interfaces/menu-item.interface';
import { isLastItem } from '../../utils/is-last-item.util';
import { ACCOUNT_MENU_ITEMS } from '../../constants/account-menu-items.constant';
import { APP_ROUTES } from '../../constants/app-routes.constant';
import { USER_MENU_ITEMS } from '../../constants/user-menu-items.constant';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit, OnDestroy {
  private isDesktopSubscription: Subscription;
  private isLoadingUserAuthSubscription: Subscription;
  private userInfoSubscription: Subscription;
  private copiedProtocol: boolean;
  public isDesktop: boolean;
  public userInfo: UserInfo;
  public userMenuItems: MenuItemInterface[] = USER_MENU_ITEMS;
  public accountMenuItems: MenuItemInterface[] = [...USER_MENU_ITEMS, ...ACCOUNT_MENU_ITEMS];
  public isUserAuthLoading = true;

  get userName(): string {
    return this.isDesktop ? this.userInfo['full_name'] : this.userInfo['first_name'];
  }

  get iconName(): string {
    return this.isDesktop ? 'chevron-down' : 'chevron-left';
  }

  get bsToggle(): string {
    return this.userInfo ? (this.isDesktop ? 'dropdown' : 'offcanvas') : '';
  }

  get bsTarget(): string {
    return this.userInfo ? (this.isDesktop ? '' : '#offcanvas') : '';
  }

  get attendanceProtocol(): number {
    return this.attendanceService.attendanceProtocol;
  }

  constructor(
    private attendanceService: AttendanceService,
    private authService: AuthService,
    private router: Router,
    private toastrService: ToastrService,
    private userService: UserService,
    private viewportService: ViewportService
  ) {}

  ngOnInit(): void {
    this.isDesktopSubscription = this.viewportService.isDesktopObservable.subscribe((value) => {
      this.isDesktop = value;
    });

    this.isLoadingUserAuthSubscription = this.authService.isLoadingUserAuthObservable.subscribe((value) => {
      this.isUserAuthLoading = value;
    });

    this.userInfoSubscription = this.userService.userInfoObservable.subscribe((value) => {
      if (value) {
        this.userInfo = value;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.isDesktopSubscription) {
      this.isDesktopSubscription.unsubscribe();
    }

    if (this.isLoadingUserAuthSubscription) {
      this.isLoadingUserAuthSubscription.unsubscribe();
    }

    if (this.userInfoSubscription) {
      this.userInfoSubscription.unsubscribe();
    }
  }

  public async handleCopyProtocolButtonClick(): Promise<void> {
    if (!this.copiedProtocol) {
      await navigator.clipboard.writeText(this.attendanceProtocol.toString());

      this.copiedProtocol = true;

      this.toastrService.success('Protocolo copiado!');

      setTimeout(() => {
        this.copiedProtocol = false;
      }, 2000);
    }
  }

  public login(): void {
    this.authService.initLoginCidadao();
  }

  public logout(): void {
    if (this.authService.skipSatisfactionSurvey) {
      this.authService.logout();
    } else {
      this.router.navigate([APP_ROUTES.satisfactionSurvey.url]);
    }
  }

  public isLastItem(array: any[], index: number): boolean  {
    return isLastItem(array, index);
  }
}
